
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInTaxDialog extends Common.GridEditorDialog<BranchInTaxRow> {
        protected getFormKey() { return BranchInTaxForm.formKey; }
        //protected getIdProperty() { return BranchInTaxRow.idProperty; }
        protected getLocalTextPrefix() { return BranchInTaxRow.localTextPrefix; }
        protected getNameProperty() { return BranchInTaxRow.nameProperty; }
        //protected getService() { return BranchInTaxService.baseUrl; }
        protected getDeletePermission() { return BranchInTaxRow.deletePermission; }
        protected getInsertPermission() { return BranchInTaxRow.insertPermission; }
        protected getUpdatePermission() { return BranchInTaxRow.updatePermission; }

        protected form = new BranchInTaxForm(this.idPrefix);

        constructor() {
            super();
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.TaxRate);
            q.setTextRightAlign(this.form.TaxAmount);

        }

    }
}